import React from 'react';
import { IRowMeta } from '../../../../redux/slices/oldBuilder';
import { IFilterFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import { BuilderFilterFields } from '../../BuilderFields/BuilderFilterFields';

interface IProps {
  rowMeta: IRowMeta;
  globalFilter: IFilterFieldsFragment;
}

const GlobalFilter = ({ rowMeta, globalFilter }: IProps) => (
  <BuilderFilterFields rowMeta={rowMeta} filter={globalFilter} />
);

export default GlobalFilter;
